import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { useMutation } from '@tanstack/react-query';

const CalculateSolarDesignPerformance = graphql(`
  mutation CalculateSolarDesignPerformance(
    $projectId: ID!
    $designId: ID!
    $expectedRevision: Int!
  ) {
    calculateSolarDesignPerformance(
      projectId: $projectId
      designId: $designId
      expectedRevision: $expectedRevision
    ) {
      id
      revision
      state
    }
  }
`);

export const useCalculateSolarDesignPerformance = (projectId: string) =>
  useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (input: { designId: string; expectedRevision: number }) =>
      gqlClient.request(CalculateSolarDesignPerformance, {
        projectId,
        ...input,
      }),
  });
